import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnChanges, OnInit, Output, QueryList, Renderer2, SecurityContext, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AgendaTaskEditDialogComponent } from '../agenda-task-edit-dialog/agenda-task-edit-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MinutesCollabDetails, MeetingResponse, agendaList } from 'src/app/models/basicMeetingModel';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { DomSanitizer } from '@angular/platform-browser';
// import * as $ from 'jquery';
import $ from 'jquery';

import { Popover } from 'bootstrap';
import { UtilityService } from 'src/app/service/utility.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { AttachmentService } from 'src/app/service/attachment.service';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { AgendaEditDialogComponent } from '../agenda-edit-dialog/agenda-edit-dialog.component';
import { PredefinedNotesFieldComponent } from '../dialog-predefined-notes/predefined-notes-field.component';
import { AgendaNotesFieldComponent } from '../dialog-notes-field/agenda-notes-field.component';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';
import { CdTimerComponent } from 'angular-cd-timer';
import { TimerComponent } from '../timer/timer.component';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { PermissionService } from 'src/app/service/permission.service';
import { Globals } from 'src/app/service/global';
import { environment_const, meetingTourValues, scheduleMeetingTourValues, pastMeetingTourValues } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { log } from 'console';
import { CK5_EDITOR, CK5_TOOLBAR, CK5_READONLY_CONFIG, buildCk5Config, setupCk5UploadAdapter as setupCommonCk5UploadAdapter } from 'src/app/config/ck5-common';
import Quill from 'quill';
import { setupQuillUploadAdapter } from 'src/app/config/quill-common';
import { quillSharedToolbar } from 'src/app/config/quill-shared-toolbar';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { AttendeeService } from 'src/app/service/attendee.service';
import { FreeFormCommonService } from 'src/app/service/free-form-common.service';
// import {GeneralHtmlSupport} from '@ckeditor/ckeditor5-html-support';

@Component({
  selector: 'app-instant-meeting-agenda',
  templateUrl: './instant-meeting-agenda.component.html',
  styleUrls: [
    './instant-meeting-agenda.component.css',
    '../../../assets/adc-styles/ckeditor-agenda-custom.css'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstantMeetingAgendaComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() timerTrackerArray: number[] = [];
  @Output() updateTimerTracker = new EventEmitter<number[]>();
  @Output() viewPreviousAgenda = new EventEmitter<any>()
  matDialogRef!: MatDialogRef<AttachmentDialogComponent>;
  @Input()
  meetingResponse !: MeetingResponse;
  // @Input('agList') agList:any;
  meetingStarted = false;
  agendaAttachResp: any;
  attachmentTotalCnt :any =true;
  loggedInUser = localStorage.getItem("userId");
  @ViewChild('TimerComponent') timerTrigger!: TimerComponent;
  @ViewChildren('minuteItem') minuteItems!: QueryList<ElementRef>;
  attachmentCount: any;
  attachmentResp: any;
  responsevalue: any;
  attachmentIcon = 'Y';
  @Input() pinDialogTriggered = false
  @Input() contentEditableBool : any
  @Input() level: number = 0;
  @Input() indexNumber: number = 0;
  @Output() subAgendaEventEmitter=new EventEmitter<MeetingResponse>()
  @Input('inFullscreen') inFullscreen: boolean = false;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
    );
    isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Medium
    )
    isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Small
    )
  draggedId: any;
  draggedEntityType: any;
  draggedObj: any;
  meetingTourValues = meetingTourValues;
  scheduleMeetingTourValues = scheduleMeetingTourValues;
  pastMeetingTourValues = pastMeetingTourValues;
  videoSectionStatusChecker = true;
  disableAgendaIcon: any;
  editCollabData = <MinutesCollabDetails>{};

  @ViewChild('element') agendaRights!: ElementRef;
  selectedTabName: any;
  lengthForMinutes: void | undefined;
  minutesLengthChecker: void | undefined;
  currentDurationVal: any;
  previewsAgendaEditIcons: any;
  disaleAttachmentFileIcon: any;
  dropTargetIds: any = [];
  nodeLookup: any = {};
  dropTargetMinIds: any = [];
  minLookup: any = {};
  nodes: any;

  //@Output() isTaskUpdated : any = new EventEmitter();
  
  // CKEditor 5 configuration (legacy - being replaced by Quill)
  public Editor: any = CK5_EDITOR;
  public ck5Config: any = {};
  public ck5ReadOnlyConfig: any = CK5_READONLY_CONFIG;
  private activeAgendaEditor: any;
  private agendaEditors: Map<number, any> = new Map();
  private toolbarInteracting = false;
  private blurSavingGuard: boolean = false;

  // Quill.js configuration
  private quillAgendaInstances: Map<number, Quill> = new Map();
  private activeQuillAgenda?: Quill;
  private agendaUserInteracted: Map<number, boolean> = new Map();
  
  // @ Mention dropdown for presenters
  presenterMentionList: Map<number, any[]> = new Map();
  showPresenterDropdown: Map<number, boolean> = new Map();
  presenterActiveIndex: Map<number, number> = new Map();
  presenterMentionIndex: Map<number, number> = new Map();
  dropdownPositionMap: Map<number, { top: number; left: number }> = new Map();
  
  public quillAgendaConfig: any = {
    enableTable : true,
    letter : false,
    modules: {
    toolbar: {
    container: [
    ['bold', 'italic', 'underline', 'strike'],    
    [{ list: 'ordered' }, { list: 'bullet' }],    
    [{ indent: '+1' }, { indent: '-1' }],        
    [{ color: [] }, { background: [] }],        
    ['image','link'],
    ],
    handlers: {
    insertheaderorfooter: () => {}, // just placeholder, real action via emitter
    subreport: () => {},
    preview: () => {},
    print: () => {},
    formula: () => {},
    },
    },
    },
    sharedToolbar : {enabled:true , selectorId:'quill-shared-toolbar'},
    placeholder: " ",
    theme: 'snow',
    };

  constructor(@Inject(DOCUMENT) private document: Document, private permissionService:PermissionService,public globals:Globals, public sideNavService: SideNavServiceService, private readonly breakpointObserver: BreakpointObserver,public meetingService: MeetingService, private webTranService:WebsocketTransferService,private dialog: MatDialog, public commonService: FreeFormAgendaService, public domSanitizer: DomSanitizer, public utilService: UtilityService, public commonMinService: FreeFormMinutesService, public attachService: AttachmentService, public cd: ChangeDetectorRef, private agoraConfig: AgoraConfigService,private attendeeService: AttendeeService,private comService: FreeFormCommonService) {
    commonService.agendaRes.subscribe((req: any) => {
      // Parent (schedule-and-instant) mutates meetingResponse in place.
      // Since this component uses OnPush, mark for check when agenda model updates
      try { this.cd.markForCheck(); } catch {}
    });
  }
  ngAfterViewInit(): void {
    
    setTimeout(() => {

      const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
      if(!roleFlag){
        this.selectedTabName = roleFlag;
        this.disableAgendaIcon = true;
      }

    }, 1000);
    //throw new Error('Method not implemented.');
    this.minuteItems.changes.subscribe((list: QueryList<ElementRef>) => {
      if (list.length) {
      if(this.meetingResponse.commonMomStatusCode!=undefined && this.meetingResponse.commonMomStatusCode==environment_const.momApproveStatus){
        this.sideNavService.disablePageAfterApproval();
      }else{
        this.sideNavService.enableAfterApproveToNormal();
      }      }
    });

    // Also handle initial load
    if (this.minuteItems.length) {
      
      if(this.meetingResponse.commonMomStatusCode!=undefined && this.meetingResponse.commonMomStatusCode==environment_const.momApproveStatus){
        this.sideNavService.disablePageAfterApproval();
      }else{
        this.sideNavService.enableAfterApproveToNormal();
      }    }
  }
 

  options: any
  attachCount: boolean = true;
  today: any
  currentDate: any
  popoverHtmlStr: any;
  popoverSafeHtml: any;
  showTimer = false;
  expansion = true
  secondExpansion = false;

  dropActionTodo: any = null;

  //UI Change
  dragPositionIndex : any
  showTimerFunc(obj: any) {
     var id=obj.agendaId;
    const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }

    $('#clockIcon'+id).attr('disabled','true')
    $('#clockIcon'+id).addClass('disable-clock-class')

    // DO NOT auto-click - user should manually start timer
    // document.getElementById('startTimer'+id)?.click()

    if(this.instantMeetingStarted == true){
      this.meetingStarted = true;
      this.timerTrackerArray.push(id)
      if(this.timerTrackerArray.length != 0){
        for(let i  = 0; i < this.timerTrackerArray.length - 1; i++ ){
          const pauseTimer = document.getElementById('pauseTimer'+this.timerTrackerArray[i]);
          const playTimer = document.getElementById('playTimer'+this.timerTrackerArray[i]);
          if(pauseTimer != null){
            pauseTimer.click()
          }

        }

      }
      
       const timer = (<HTMLElement>document.getElementById('timer'+id));
      
    }
    
    // $('#timer'+id).css("display", "block")
     $('timer'+id).attr('hidden','false')
    this.commonService.collapAgendaList(obj,'start');
    this.updateTimerTracker.emit(this.timerTrackerArray);
  }
  ngOnInit(): void {
    this.commonMinService.setActivateCkEditor(true);
    
    // CKEditor5 config (legacy)
    this.ck5Config = buildCk5Config(this.meetingResponse);
    this.ck5Config.mention = {
      feeds: [
        {
          marker: '@',
          minimumCharacters: 0,

          feed: (queryText: any) => {
            const editableEl2 = this.activeAgendaEditor.ui.view.editable.element as HTMLElement;
            return this.getMentionUsers(editableEl2)
              .then((users: any) => {
                if (!queryText) {
                  return users;
                }
                return users.filter((u: any) =>
                  u.name.toLowerCase().includes(queryText.toLowerCase())
                );
              });
          },

          itemRenderer: (item: any) => {
            const container = document.createElement('div');
            container.className = 'mention-item';

            const nameEl = document.createElement('div');
            nameEl.className = 'mention-item__name';
            nameEl.textContent = item.name;

            const emailEl = document.createElement('div');
            emailEl.className = 'mention-item__email';
            emailEl.textContent = item.email || '';

            container.appendChild(nameEl);
            container.appendChild(emailEl);

            return container;
          }
        }
      ]
    }
    this.options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }
    this.nodes = this.meetingResponse.agendaList;
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US", this.options)
    const tempInt = setInterval(() => {
       
      if(this.meetingResponse!=undefined){
        var agendaList = this.meetingResponse.agendaList;
        if (agendaList != null) {
          this.prepareDragDrop(this.meetingResponse.agendaList);
          clearInterval(tempInt);
          agendaList.forEach((ag: any) => {
            this.attachmentCount = ag.attachmentFileCount + ag.attachmentLinkCount;
            if(ag.agendaFlag=='START')
            document.getElementById('clockIcon'+ag.agendaId)?.click();
            
            

          });
        }
      }
     },500);
    if(this.sideNavService.openInstantMeetingTransmitter()){
      this.videoSectionStatusChecker = false
    }
    else{
      this.videoSectionStatusChecker = true
    }
  }

  ngAfterViewChecked(){
    if(this.sideNavService.openInstantMeetingTransmitter()){
      this.videoSectionStatusChecker = this.sideNavService.getVideoPaneOpenCloseStatus()
    }
  }

  prepareDragDrop(nodes: any) { 
 
    nodes.forEach((node: any) => {
      this.dropTargetIds.push(node.agendaId);
      this.nodeLookup[node.agendaId] = node;
      this.prepareDragDrop(node.subtopics);
      node.minutesList.forEach((min: any) => {
        this.dropTargetMinIds.push(min._id);
        this.minLookup[min._id] = node;
   

      })
 
  });

  }

  alertShown = false;
  dragMoved(event: any, main: boolean = false) {
 
    
    if(main) {
      if(!this.alertShown) {
        alert('Main agenda can not be moved !');
        this.alertShown = true;
        event.preventDefault();
      } 
      return;
    } else {
      this.alertShown = false;
      let e = this.document.elementFromPoint(event.pointerPosition.x,event.pointerPosition.y);
      
      if (!e) {
          this.clearDragInfo();
          return;
      }
      let container = e.classList.contains("node-item") ? e : e.closest(".node-item");
      
      if (!container) {
          this.clearDragInfo();
          return;
      }
      this.dropActionTodo = {
          targetId: container.getAttribute("data-id")
      };
      
      const targetRect = container.getBoundingClientRect();
      const oneThird = targetRect.height / 3;

      if (event.pointerPosition.y - targetRect.top < oneThird) {
          // before
          this.dropActionTodo["action"] = "before";
      } else if (event.pointerPosition.y - targetRect.top > 2 * oneThird) {
          // after
          this.dropActionTodo["action"] = "after";
      } else {
          // inside
          this.dropActionTodo["action"] = "inside";
      }
      
      this.showDragInfo();
    }
      
  }

  dragMinMoved(event: any) {
    let e = this.document.elementFromPoint(event.pointerPosition.x,event.pointerPosition.y);
    
    if (!e) {
        this.clearDragInfo();
        return;
    }
    let container = e.classList.contains("min-item") ? e : e.closest(".min-item");
    
    let agContainer = e.classList.contains("node-item") ? e : e.closest(".node-item");    

 

    
    if (!container) {
        this.clearDragInfo();
        const targetRect = agContainer?.getBoundingClientRect();
        const oneThird = targetRect!.height / 3;

        // const targetAgenda = agContainer!.getBoundingClientRect();
        // const oneThirdAgenda = targetAgenda.height / 3;

        if (event.pointerPosition.y - targetRect!.top < oneThird) {
            // before
            this.dropActionTodo = {
              targetId: agContainer!.getAttribute("data-id")
            };
            this.dropActionTodo["action"] = "before";
        } else if (event.pointerPosition.y - targetRect!.top > 2 * oneThird) {
            // after
            this.dropActionTodo = {
              targetId: agContainer!.getAttribute("data-id")
            };
            this.dropActionTodo["action"] = "after";
        } else {
            // inside
            this.dropActionTodo = {
              targetId: agContainer!.getAttribute("data-id")
            };
            this.dropActionTodo["action"] = "inside";
        }
        this.dropActionTodo.level = 'agenda';
    } else {
      const targetRect = container.getBoundingClientRect();
      const oneThird = targetRect.height / 3;

      // const targetAgenda = agContainer!.getBoundingClientRect();
      // const oneThirdAgenda = targetAgenda.height / 3;

      if (event.pointerPosition.y - targetRect.top < oneThird) {
          // before
          this.dropActionTodo = {
            targetId: container.getAttribute("data-id")
          };
          this.dropActionTodo["action"] = "before";
      } else if (event.pointerPosition.y - targetRect.top > 2 * oneThird) {
          // after
          this.dropActionTodo = {
            targetId: container.getAttribute("data-id")
          };
          this.dropActionTodo["action"] = "after";
      } else {
          // inside
          this.dropActionTodo = {
            targetId: container.getAttribute("data-id")
          };
          this.dropActionTodo["action"] = "inside";
      }
    }

    this.showDragInfo();
}

  drop(event: any) {
      if (!this.dropActionTodo) return;
 
      this.prepareDragDrop(this.meetingResponse.agendaList);
      const draggedItemId = event.item.data;
      const parentItemId = event.previousContainer.id;
      const targetListId = this.getParentNodeId(this.dropActionTodo.targetId, this.meetingResponse.agendaList, 'main');
      var pageIns = this;
      var agSeqMap: any = new Object();
      var agendaJSONReq: any;
   
      const draggedItem = this.nodeLookup[draggedItemId];
      const oldItemContainer = parentItemId != 'main' ? this.nodeLookup[parentItemId].subtopics : this.meetingResponse.groupedAgendaList![0].subtopics;
      const newContainer = targetListId != 'main' ? this.nodeLookup[targetListId].subtopics : this.meetingResponse.groupedAgendaList![0].subtopics;
      let i = oldItemContainer.findIndex((c: any) => c.agendaId === draggedItemId);
      if(i >= 0) {
        oldItemContainer.splice(i, 1);
      } else {
        oldItemContainer.splice(0, 1);
      }

      // if(draggedItem.entityType == "AG" || draggedItem.entityType == "SG") {

        draggedItem.parentAgendaId = newContainer.agendaId;

  

      let path;
      let parentId;
      let dropedParentAgendaId;
      switch (this.dropActionTodo.action) { 
          case 'before':
            const targetIndex1 = newContainer.findIndex((c: any) => c.agendaId == this.dropActionTodo.targetId);
            newContainer.splice(targetIndex1, 0, draggedItem);
       
            for(let i of newContainer) {
              if(i.agendaId == draggedItemId) {
                if(newContainer[0].agendaId == draggedItemId) {
                  i.path = newContainer[1].path;
                } else {
                  i.path = newContainer[0].path;
                }
              }
            }
            break;
          case 'after':
              const targetIndex = newContainer.findIndex((c: any) => c.agendaId == this.dropActionTodo.targetId);
              // if (this.dropActionTodo.action == 'before') {
              //     newContainer.splice(targetIndex, 0, draggedItem);
              // } else {
                  newContainer.splice(targetIndex + 1, 0, draggedItem);
             
                  for(let i of newContainer) {
                    if(i.agendaId == draggedItemId) {
                      if(newContainer[0].agendaId == draggedItemId) {
                        i.path = newContainer[1].path;
                      } else {
                        i.path = newContainer[0].path;
                      }
                    }
                  }
              // }
              break;

          case 'inside':
              this.nodeLookup[this.dropActionTodo.targetId].subtopics.push(draggedItem)
              this.nodeLookup[this.dropActionTodo.targetId].isExpanded = true;
              dropedParentAgendaId = +this.dropActionTodo.targetId
              for(let i of this.nodeLookup[this.dropActionTodo.targetId].subtopics) {
                i.path = this.nodeLookup[this.dropActionTodo.targetId].path + '.' + i.agendaId;
                i.parentAgendaId = this.nodeLookup[this.dropActionTodo.targetId].agendaId;
                parentId = i.parentAgendaId;
                path = i.path;
              }
              break;
      }
      this.agSeqMap = [];
      this.meetingResponse.groupedAgendaList?.forEach((agElem: any, agIndex: number) => {
        
        this.addAgendaIds(agElem, this.agSeqMap);
        
      })


      let parentAgendaId: any;
      for(let i of this.allAgendaWithSub) {
   
        
        if(i.subtopics && i.subtopics.some((a: any) => a.agendaId == draggedItemId)) {
          parentAgendaId = i.agenda;
        }
      }

      
      const obj = this.agSeqMap.reduce((acc: any, curr: any, index: any) => {
        acc[index + 1] = curr;  // Assign each element to a key starting from 1
        return acc;
      }, {});
      var agSeqList = JSON.stringify(obj);

      
      agendaJSONReq = { "meetingId": draggedItem.meetingId, "agSeqList": agSeqList, "parentAgendaId": parentAgendaId, "agendaId": draggedItemId};


      this.meetingService.updateAgendaSequence(JSON.stringify(agendaJSONReq)).subscribe(res => {
        
      });

      
      // this.meetingResponse.agendaList?.map((a: any) => {
      //   if(a.agendaId == draggedItemId) {
      
          
      //   }
      // })
    
 
      // this.commonService.updateAgenda(document.getElementById("meetAgendaId" + draggedItemId), null, 'B', path, parentId);
 
 
      // this.trackMeetingResponse();
      this.clearDragInfo(true)
  }

  agSeqMap: any = [];
  allAgendaWithSub: any = [{}];
  addAgendaIds(agElem: any, agSeqMap: number[]): void {
    // Add the current agenda ID to the sequence map
    this.agSeqMap.push(agElem.agendaId);
        
    // If there are subtopics, iterate over them recursively
    if (agElem.subtopics) {
      this.allAgendaWithSub.push({agenda: agElem.agendaId, subtopics: agElem.subtopics});
      for (let i of agElem.subtopics) {
        this.addAgendaIds(i, agSeqMap); // Recurse for each subtopic
      }
    }
  }

  dropMin(event: any) {
    if (!this.dropActionTodo) return;
 
      const draggedItemId = event.item.data;
      const parentItemId = event.previousContainer.id;
      if(this.meetingResponse.agendaList && this.dropActionTodo.targetId != null) {
        for(let item of this.meetingResponse.agendaList) {

          // const targetListId = this.getParentMinId(this.dropActionTodo.targetId, item.minutesList, item.agendaId);
          // const targetListId = event.previousContainer.id;
          const targetListId = this.dropActionTodo.targetId;

          
          //     '\nmoving\n[' + draggedItemId + '] from list [' + parentItemId + ']',
          //     '\n[' + this.dropActionTodo.action + ']\n[' + this.dropActionTodo.targetId + '] from list [' + targetListId + ']');
       
          // const draggedItem = this.minLookup[draggedItemId];
          this.prepareDragDrop(this.meetingResponse.agendaList);
          let draggedItem;
       
          // const oldItemContainer = parentItemId != item.agendaId ? this.minLookup[parentItemId] : item;
          const oldItemContainer = parentItemId;
          let newContainer;
          if(this.dropActionTodo.level == 'agenda') {
            newContainer = targetListId != 'main' ? this.nodeLookup[targetListId] : this.meetingResponse.agendaList[0];
          } else {
            newContainer = targetListId != item.agendaId ? this.minLookup[targetListId] : item;
          }
         for(let i of oldItemContainer.minutesList) {
            if(i._id && i._id == draggedItemId) {
              draggedItem = i;
         
            }
          }
          
          draggedItem.agendaId = newContainer.agendaId;

          // if(this.dropActionTodo.action = 'inside') {
            let i = oldItemContainer.minutesList.findIndex((c: any) => c._id === draggedItemId);
            oldItemContainer.minutesList.splice(i, 1);
          // }


          

          if(draggedItem.entityType == "MN" || draggedItem.entityType == "MD") {
            const reqJson={
              "agendaId" : newContainer.agendaId,
              
            }
       
            const minJson={
              "minutesId": draggedItemId
            }
  
            const saveUrl = this.commonService.getSaveUrl ("Y",draggedItem.entityType,minJson);
       
  
            this.commonService.saveMinutesAttributes({}, reqJson, saveUrl, "Y");

          } else if(draggedItem.entityType == "AI") {
            const taskId = {
              "taskId": draggedItemId
            }

            const taskRequestJson = {
              "taskId": draggedItem.taskId,
              "agendaId": newContainer.agendaId,
              "minutesId": draggedItem.taskId?.replace("T_", ''),
              "meetingId": draggedItem.meetingId
            }
       
            this.meetingService.saveTaskAgendaId(JSON.stringify(taskRequestJson), draggedItem.taskId).subscribe((res: any) => {
         
            })
          }
  
            var minSequenceMap: any = new Object();
            var agendaId='';
            // this.draggedObj.agendaId = this.meetingResponse.agendaList![0].agendaId;
            // this.meetingResponse.agendaList![0].minutesList!.forEach((agElem: any, agIndex: any) => {
            //     agendaId = agElem.agendaId;
            //     const minid = agElem._id;
            //     const seq = agIndex + 1;
            //     minSequenceMap[seq] = minid;
            // });
            // var minSeqList = JSON.stringify(minSequenceMap);
            // var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": minSeqList, "agendaId": agendaId }
            const arr = newContainer.path.split('.').map(Number);
            const obj = arr.reduce((acc: any, curr: any, index: any) => {
              acc[index + 1] = curr;  // Assign each element to a key starting from 1
              return acc;
            }, {});
            var agSeqList = JSON.stringify(obj);
            var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": agSeqList, "agendaId": newContainer.agendaId }
            this.meetingService.updateMinSequence(JSON.stringify(jsonReq)).subscribe(res => {
              const minutesResp = res.body;
            });

          
     
          if(this.dropActionTodo) {
            switch (this.dropActionTodo.action) {
              case 'before':
              case 'after':
                  const targetIndex = newContainer.minutesList.findIndex((c: any) => c._id === this.dropActionTodo.targetId);
                  if (this.dropActionTodo.action == 'before') {
                      newContainer.minutesList.splice(targetIndex, 0, draggedItem);
                  } else {
                      newContainer.minutesList.splice(targetIndex + 1, 0, draggedItem);
                  }
             
                  break;

              case 'inside':
                  // this.nodeLookup[this.dropActionTodo.targetId].subtopics.push(draggedItem)
                  // this.nodeLookup[this.dropActionTodo.targetId].isExpanded = true;
                  newContainer.minutesList.push(draggedItem);
                  break;
          }

          this.clearDragInfo(true)
          }
        }
   
      }
  }

  getParentNodeId(id: string, nodesToSearch: any, parentId: any): any {
      for (let node of nodesToSearch) {
          if (node.agendaId == id) return parentId;
          let ret = this.getParentNodeId(id, node.subtopics, node.agendaId);
          if (ret) return ret;
      }
      return null;
  }

  getParentMinId(id: string, nodesToSearch: any, parentId: any): any {
    for (let node of nodesToSearch) {
        if (nodesToSearch._id == id) return parentId;
        // let ret = this.getParentNodeId(id, node.subtopics, node.agendaId);
        
        // if (ret) return ret;
    }
    return null;
  }

  showDragInfo() {
      this.clearDragInfo();
      
      if (this.dropActionTodo !== null) {
        const element = this.document.getElementById("node-" + this.dropActionTodo.targetId);
        
        if (element) {
       
            element.classList.add("drop-" + this.dropActionTodo.action);
        } else {
            console.warn("Element not found: node-" + this.dropActionTodo.targetId);
        }
    }
  }
  clearDragInfo(dropped = false) { 
      if (dropped) {
          this.dropActionTodo = null;
      }
      this.document
          .querySelectorAll(".drop-before")
          .forEach(element => element.classList.remove("drop-before"));
      this.document
          .querySelectorAll(".drop-after")
          .forEach(element => element.classList.remove("drop-after"));
      this.document
          .querySelectorAll(".drop-inside")
          .forEach(element => element.classList.remove("drop-inside"));
  }


  trigger(){
    // document.getElementById('menu')?.requestFullscreen()
  }

  //UI Team changes
  @Input()
  instantMeetingStarted !: any


  //agenda task edit dialog

  editDialog() {
    //window.alert("edit dialog triggered")
    const dialogRef = this.dialog.open(AgendaTaskEditDialogComponent, {
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                 
                  maxHeight: "100vh",
                  width: "50%",
                  maxWidth : "100%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    })
  }

  //notes dialog

  openNotesDialog(e: any) {
    const dialogRef = this.dialog.open(AgendaNotesFieldComponent, {
      data: { e }, disableClose: true,
      panelClass: ['animate__animated','animate__slideInLeft'],
                  // disableClose: false,
                  position : {
                    left : "0%"
                  },
                  maxWidth: "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    })
  }

  // agenda edit dialog

  agendaEditDialog(req: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }
    const reqJSON = { "meetingId": req.meetingId, "agendaId": req.agendaId };
    this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
      const e = data.body;
      const agEditDialog = this.dialog.open(AgendaEditDialogComponent, {
        data: { "agenda":e ,"meetingres" :this.meetingResponse}, disableClose: true,
        panelClass: ['animate__animated','animate__slideInLeft'],
                  
                  position : {
                    left : "0%"
                  },
                  maxWidth:"100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
      });
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          agEditDialog.updateSize('70vw','100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          agEditDialog.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          agEditDialog.updateSize('100vw', '100vh');
        }
      });
      agEditDialog.afterClosed().subscribe((data:any)=>{
        if (data) {          
            // if (this.agList.agendaId === data.agendaId) {
            //   this.agList = { ...this.agList, ...data };
            // }
            this.meetingResponse.groupedAgendaList = this.hasId(this.meetingResponse.groupedAgendaList, data.agendaId, data.agendaTitle);
          this.cd.detectChanges();
              this.updateAgDuration($.event, data.agendaId, data.agendaDuration);
        }        
        mediumDialogSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
      });
    })
  }

  hasId(data: any, targetId: string, updatedTitle: any): any {
    return data.map((item: any) => {
      const updatedItem = { ...item };
 
      if (updatedItem.agendaId === targetId) {
        updatedItem.agendaTitle = updatedTitle;
      }
 
      if (updatedItem.subtopics && updatedItem.subtopics.length > 0) {
        updatedItem.subtopics = this.hasId(updatedItem.subtopics, targetId, updatedTitle);
      }
 
      return updatedItem;
    });
   
  }
  //agenda predefined dialog

  openPreDefinedDialog(e: any) {
    const dialogRef = this.dialog.open(PredefinedNotesFieldComponent, {
      data: { e }, disableClose: true,
      panelClass: ['animate__animated','animate__slideInLeft'],
                  // disableClose: false,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        dialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    })
  }

  getAttachCount(e: any) {
    const reqJSON = { "meetingId": e.meetingId, "agendaId": e.agendaId };
    
    this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
      this.agendaAttachResp = data.body;
      
      this.attachCount = false;
    });
  }


  //agenda confidential dialog
  openConfidentialDialog(e: any, m: any) {
    const attchDialog = this.dialog.open(AttachmentDialogComponent, {
      data: {
        e,
        m,
        "data" : this.contentEditableBool,
        "disaleAttachmentFileIcon":this.disaleAttachmentFileIcon
      },
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        attchDialog.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        attchDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    });
    attchDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      const reqJSON = {
        "meetingId": e.meetingId,
        "agendaId": e.agendaId
      };
       this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
        this.responsevalue = data
        this.editCollabData=<MinutesCollabDetails>{};
        
        if (data != undefined) {
         const agendaList = this.meetingResponse.agendaList;
         if (agendaList != null) {
           agendaList.forEach((ag: any,agIndex:any) => {
             if(ag.agendaId==e.agendaId){
              ag.attachmentTotalCnt=data.body.attachmentTotalCnt;
              this.editCollabData.elementId=e.agendaId;
              this.editCollabData.collabType='AGATTACH';
              this.editCollabData.agElemPosition=agIndex;
              this.editCollabData.attachmentTotalCnt=ag.attachmentTotalCnt;
              const sentUserName = localStorage.getItem("userName");
              if(sentUserName!=null && sentUserName!=undefined){
                this.editCollabData.sentByUserName=sentUserName;
              }
              this.editCollabData.userId=localStorage.getItem("userId")
              this.editCollabData.meetingId=this.meetingResponse.meetingId;
              if(this.meetingResponse.meetingType!= undefined && this.meetingResponse.meetingType!=null&& this.meetingResponse.meetingType!=""){
                this.editCollabData.meetTypeVal=this.meetingResponse.meetingType;
              }
                
              this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.editCollabData).subscribe((data) => {
              });
             }
           });
         }
        }
      });

    })
    ////consolee.log("value of e",e,"value of m",m)
  }

  //agenda link dialog

  addNewLink(entityId: any, meetingId: any) {
    const addLinkDialog = this.dialog.open(AddLinkDialogComponent, {
      data: { entityId, meetingId, "entityType": "AG", "attachmentMode": "LI","data" : this.contentEditableBool,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon },
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: false,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        addLinkDialog.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        addLinkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        addLinkDialog.updateSize('100vw', '100vh');
      }
    });
    addLinkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      const reqJSON = {
        "meetingId": meetingId,
        "agendaId": entityId
      };
      
      this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
        this.responsevalue = data
        this.editCollabData=<MinutesCollabDetails>{};
        
        if (data != undefined) {
         const agendaList = this.meetingResponse.agendaList;
         if (agendaList != null) {
           agendaList.forEach((ag: any,agIndex:any) => {
             if(ag.agendaId == entityId){
              ag.attachmentTotalCnt=data.body.attachmentTotalCnt;
              this.editCollabData.elementId=ag.agendaId;
              this.editCollabData.collabType='AGATTACH';
              this.editCollabData.agElemPosition=agIndex;
              this.editCollabData.attachmentTotalCnt=ag.attachmentTotalCnt;
              const sentUserName = localStorage.getItem("userName");
              if(sentUserName!=null && sentUserName!=undefined){
                this.editCollabData.sentByUserName=sentUserName;
              }
              this.editCollabData.userId=localStorage.getItem("userId")
              this.editCollabData.meetingId=this.meetingResponse.meetingId;
              if(this.meetingResponse.meetingType!= undefined && this.meetingResponse.meetingType!=null&& this.meetingResponse.meetingType!=""){
                this.editCollabData.meetTypeVal=this.meetingResponse.meetingType;
              }
              this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.editCollabData).subscribe((data) => {
              });
             }
           });
         }
        }
      });

    })
  }
  ngOnDestroy(){
    // Guard against missing CKEditor 4 global after migration
    const w: any = (window as any);
    if (w && w.CKEDITOR && w.CKEDITOR.instances) {
      for (const instance in w.CKEDITOR.instances) {
        try {
          w.CKEDITOR.instances[instance].destroy();
        } catch {}
      }
    }
  this.disposeDurationPopup('popover');

  }

  descriptionVissible = false;

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;
  @Output() latestMeetingResponse: any = new EventEmitter();
  spanChecker = false

  changeSpanChecker() {
    this.spanChecker = !this.spanChecker;
  }

  @HostListener('document:click', ['$event'])
  hideDatepickerOutsideClick(e: any) {
    //var container = $(".meetingCurDate");
    const container1 = $("#editable");
    const container2 = $("#ui-datepicker-div");
    //var container3 = $("#datecls");
    const container4 = $(".ui-datepicker-prev");
    const container5 = $(".ui-datepicker-next");
    const container6 = $(".ui-icon");
    // //
    if (!container1.is(e.target) && container1.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0 && !container4.is(e.target) && container4.has(e.target).length === 0 && !container5.is(e.target) && container5.has(e.target).length === 0 && !container6.is(e.target) && container6.has(e.target).length === 0 && !$(e.target).hasClass("ui-icon-circle-triangle-e") && !$(e.target).hasClass("ui-icon-circle-triangle-w") && !$(e.target).hasClass("ui-corner-all") && !$(e.target).hasClass("hasDatepicker")) {
      $(".ui-datepicker").hide();
    }
    // if ($(e.target).parents('.popover').length ===0 &&  !$(e.target).is($('.agDurCls')) && $(e.target).parents('.agDurCls').length ===0) {
    //     $('.agDurCls').popover('hide');
    // }

  }


  openDescription() {
    this.descriptionVissible = !this.descriptionVissible
  }

  dropMinutesBetweenAgenda(event: CdkDragDrop<string[]>, minIndex : any) {
    if (event.previousContainer === event.container) {
    moveItemInArray(this.meetingResponse.agendaList![minIndex].minutesList!, event.previousIndex, event.currentIndex);

    var minSequenceMap: any = new Object();
    var agendaId='';
    this.meetingResponse.agendaList![minIndex].minutesList!.forEach((agElem: any, agIndex: any) => {
        agendaId = agElem.agendaId;
        const minid = agElem._id;
        const seq = agIndex + 1;
        minSequenceMap[seq] = minid;
      
    });
    var minSeqList = JSON.stringify(minSequenceMap);
    var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": minSeqList, "agendaId": agendaId }
    this.meetingService.updateMinSequence(JSON.stringify(jsonReq)).subscribe(res => {
      const minutesResp = res.body;
    });
    // moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      const data={}
      var agendaId='';
      transferArrayItem(
        this.meetingResponse.agendaList![this.dragPositionIndex].minutesList!,
        this.meetingResponse.agendaList![minIndex].minutesList!,
        event.previousIndex,
        event.currentIndex
      )
        if(this.draggedObj.entityType=='MN' ||this.draggedObj.entityType=='MD'){
        const reqJson={
          "agendaId" : this.meetingResponse.agendaList![minIndex].agendaId,
        }
        const minJson={
          "minutesId": this.draggedId
        }
       
        const saveUrl = this.commonService.getSaveUrl ("Y",this.draggedEntityType,minJson);
        this.commonService.saveMinutesAttributes(data, reqJson, saveUrl, "Y")  ;
       
       
      } else if(this.draggedObj.entityType=='AI'){
          let assignedTo :any
          const taskId={
            "taskId" : this.draggedId
          }
           const taskReqJson={
             "taskId": this.draggedObj.taskId,
             "agendaId": this.meetingResponse.agendaList![minIndex].agendaId ,
             "minutesId" : this.draggedObj.taskId?.replace("T_", ""),  
             "meetingId" : this.draggedObj.meetingId          
           }
           this.meetingService.saveTaskAgendaId(JSON.stringify(taskReqJson),this.draggedObj.taskId).subscribe(res => {

           });
          
      }
      var minSequenceMap: any = new Object();
      var agendaId='';
      this.draggedObj.agendaId = this.meetingResponse.agendaList![minIndex].agendaId;
      this.meetingResponse.agendaList![minIndex].minutesList!.forEach((agElem: any, agIndex: any) => {
          agendaId = agElem.agendaId;
          const minid = agElem._id;
          const seq = agIndex + 1;
          minSequenceMap[seq] = minid;
      });
      var minSeqList = JSON.stringify(minSequenceMap);
      var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": minSeqList, "agendaId": agendaId }
      this.meetingService.updateMinSequence(JSON.stringify(jsonReq)).subscribe(res => {
        const minutesResp = res.body;
      });
    }
  }

  triggerDragged(index : any, obj : any){
    this.dragPositionIndex = index
    this.draggedObj= obj;
    this.draggedId = obj['_id'];
    this.draggedEntityType =obj['entityType'];
  }

  currentDuration(el:any){
    this.currentDurationVal = el;
  }


  dropCard(event: CdkDragDrop<any>) { 
    const agSeqMap: any = new Object();
    let agendaJSONReq:any;
    moveItemInArray(this.meetingResponse.agendaList!, event.previousIndex, event.currentIndex);
    this.meetingResponse.agendaList?.forEach((agElem: any, agIndex: any) => {
      let seq=0;
      seq = agIndex + 1;
      agSeqMap[Number(seq)] = Number(agElem.agendaId);
      const agSeqList = JSON.stringify(agSeqMap);
      agendaJSONReq = { "meetingId": this.meetingResponse.meetingId, "agSeqList": agSeqList};
    });
    this.meetingService.updateAgendaSequence(JSON.stringify(agendaJSONReq)).subscribe(res => {
    });
  }

  printMsg() {
    alert("ag" + this.meetingResponse.agendaList)
  }

  ngAfterContentInit(): void {
    //this.commonService.shareDatatoService(this.meetingResponse);
    // this.printMsg();
  }

  openDurationPopover(agList: any, event: any) {
    let curElem = event.target;
    const agendaId = agList.agendaId;
    if ($(curElem).hasClass("agDurLabelCls")) {
      curElem = $(curElem).parent(".agDurCls")[0];
    }
    if (curElem != null && curElem != undefined && $(curElem).hasClass("agDurCls")) {
      const pageIns = this;
      const tempHtml = '<div class="row agDurPopupCls" id="agPopup' + agList.agendaId + '">' +
        '<div class="col-6">' +
        '<input type="text" id="agPopOverDur" class="agPopOverDurInputCls" maxlength="3" value="10">' +
        '</div>' +
        '<div class="col-6">' +
        '<button id="savePopupBtn' + agList.agendaId + '" class="btn btn-outline-primary" type="button" data-bs-toggle="popover"><mat-icon>check</mat-icon></button>' +
        '</div>' +
        '</div>';
       const popBody = document.getElementsByClassName('popover-body');
       console.log(popBody,'body element');
       
       if(popBody.length > 0){
          this.hideDurationPopup('popover');
       }

         if (!$(".popover").find("#agPopover" + agendaId).is(":visible")) {
        
        // $(".popover").find("#agPopover" + agendaId).css("display", "block");
        $("#agPopover" + agendaId).css("display", "block")
      }else {

      }

      const ins = Popover.getOrCreateInstance(curElem, {
        title: '<h4 class="custom-title" style = "margin:0px;font-size:0.9rem;font-weight:500"><i class="bi-info-circle-fill"></i> Duration</h4>',
        content: $("#agPopover" + agendaId)[0],
        html: true,
        sanitize: false,
        //trigger: 'focus'
      });
      
      ins.toggle();
      
      curElem.addEventListener('shown.bs.popover', function (elem: any) {
        const curAgId = $(curElem).parents(".agendaTitleCls").attr("agid");
        const curagTime = pageIns.utilService.nvl($("#agendaMainId" + curAgId)?.attr("agendatime")?.trim());
        ////consolee.log(curAgId+"inside show>>>"+curagTime);
        $("#agPopOverDur" + curAgId).val(curagTime);
        $("#agPopOverDur" + curAgId).focus();
      })
      
      if (!$(".popover").find("#agPopover" + agendaId).is(":visible")) {
        $(".popover").find("#agPopover" + agendaId).css("display", "block");
      }
      
    }
  }
  updateAgDuration(event: any, agendaId: any, agendaDuration:any) {
    new Promise((reject: any, resolve: any) => {      
      const agTime: any = agendaDuration == '' ? $("#agPopOverDur" + agendaId)?.val() : agendaDuration;
      
      if (this.utilService.nvl(agTime) != "") {
      this.commonService.checkAgendaDurationExceed(agTime, agendaId).then((resp:any)=>{
        

        
        if(resp > this.currentDurationVal){
          this.latestMeetingResponse.emit(this.meetingResponse)
        }
        
        
        if(resp!=undefined && resp !=null && resp != ""){
        
          // Update both agendaMainId and meetAgendaId (Quill root) with agendatime attribute
          document.getElementById("agendaMainId" + agendaId)?.setAttribute("agendatime", resp);
          document.getElementById("meetAgendaId" + agendaId)?.setAttribute("agendatime", resp);
          
          $("#meetAgendaId" + agendaId).find(".agDurCls").html('<span class="agDurLabelCls">[ </span>' + resp + '<span class="agDurLabelCls"> Minutes ]</span>');
          // Also update data-minutes attribute
          $("#meetAgendaId" + agendaId).find(".agDurCls").attr("data-minutes", resp);
        
        //$('.agDurCls').popover('hide');
      } else {
        
        //$("#meetAgendaId"+agendaId).find(".agDurCls").popover('dispose');
        $("#meetAgendaId" + agendaId).find(".agDurCls").remove();
        document.getElementById("agendaMainId" + agendaId)?.setAttribute("agendatime", "");
        document.getElementById("meetAgendaId" + agendaId)?.setAttribute("agendatime", "");
      }
      this.hideDurationPopup("popover");
      this.commonService.updateAgenda(document.getElementById("meetAgendaId" + agendaId), null, 'B');
      resolve(true);
      });

    }else{
      
    }
    }) .catch(error => {
      this.hideDurationPopup("popover");
 
    });
  }

  trackByMin(index: number, el: any): number {
    //this.commonMinService?.initializeMinSec(el._id);
    
    return el._id;
  }

  trackByAgenda(index: number, ag: any): any {
    return ag?.agendaId;
  }

  trackBySubtopic(index: number, st: any): any {
    return st?.agendaId;
  }

  hideDurationPopup(popoverCls: any) {
 
    Array.from(document.querySelectorAll("." + popoverCls)).forEach(popoverNode => {
      // //
      const ins = Popover.getInstance(popoverNode);
      if (ins != null && ins != undefined) {
        ins.hide();
      }
      const node = popoverNode as HTMLElement;
      node.style.display ='none'
    });
  }
  disposeDurationPopup(popoverCls: any) {
 
    Array.from(document.querySelectorAll("." + popoverCls)).forEach(popoverNode => {
      // //
      const ins = Popover.getInstance(popoverNode);
      if (ins != null && ins != undefined) {
        ins.dispose();
      }
    });
  }

  trackMeetingResponse() {
    this.latestMeetingResponse.emit(this.meetingResponse);
    this.subAgendaEventEmitter.emit(this.meetingResponse);

  }
  isDisplayNote(minElem: any): boolean {
    
    return true;
  }

  increementCounter(id: any) {
     const value = $('#agPopOverDur' + id).val()
    let newincCounter;
    if (value != undefined) {
      newincCounter = Number(value) + 10
      $('#agPopOverDur' + id).val(newincCounter)

    }
  }

  decreementCounter(id: any) {
    const value = $('#agPopOverDur' + id).val()
    let newdecCounter;
    if (value != undefined) {
      newdecCounter = Number(value) - 10
      $('#agPopOverDur' + id).val(newdecCounter)
    }
  }

  ngDoCheck(){
    if(this.timerTrackerArray.length != 0){
      for(var i = 0; i < this.timerTrackerArray.length; i ++){
        const doubleCheck = (<HTMLElement>document.getElementById('timer'+this.timerTrackerArray[i]));
        if(doubleCheck!=null){
          doubleCheck.hidden = false;
        }
        
      }
    }
    if(!this.contentEditableBool){
      
      for(var i = 0; i < document.getElementsByClassName('agendaEdit').length; i ++){
        document.getElementsByClassName('agendaEdit')[i].setAttribute('contenteditable','false')
      }
    }
  }

  ngOnChanges(events : any){
   
    // meetAgendaId5473
    $('html').on("click", function(event){
    
      if (event.target.className != "agDurLabelCls" && event.target.className != 'popover-header' && event.target.className != 'popover-body' && event.target.className != 'agPopOverDurInputCls' && event.target.className != 'custom-title' && event.target.className != 'ng-star-inserted' && event.target.className != 'agPopOverDurInputCls justify-content-between col-md-12 d-flex' && event.target.className != 'form-control text-center bs-timepicker-field' && event.target.className != 'arrow-one d-flex justify-content-center' && event.target.className != 'arrow-two d-flex justify-content-center' && event.target.className != 'mat-icon notranslate duration-top-buttons material-icons mat-icon-no-color' && event.target.className != 'agDurCls') {
        Array.from(document.querySelectorAll(".agDurCls")).forEach(popoverNode => {
          // //
          const ins = Popover.getInstance(popoverNode);
          if (ins != null && ins != undefined) {
            ins.hide();
          }
        });
      }
    });
    
  }
  createEmptyAgenda(event:any){
    
    const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
    const newAg='AG'
    this.commonService.trackAgendaEventOnClick(event,newAg);
    // this.trackMeetingResponse();
  }

  createEmptyNote(event:any){
   
   const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.NOTES,this.utilService.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
    const entityType="/nn";
    this.commonService.trackAgendaEventOnClick(event,entityType);

  }

  createEmptyTask(event:any){
    
    const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.TASK,this.utilService.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
    const entityType="/tt";
    this.commonService.trackAgendaEventOnClick(event,entityType);

  }

  createEmptyDecision(event:any){
    
    const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.NOTES,this.utilService.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
    const entityType="/dd";
    this.commonService.trackAgendaEventOnClick(event,entityType);

  }

  enableOrDisableAgendaEdit(e:any){

    
    


    if(e == 'Y' && this.meetingResponse.commonMomStatusCode == 'A'){
      this.previewsAgendaEditIcons = true;
    }else{
      this.previewsAgendaEditIcons = false;
    }

    
  }

  getMinComStatusCode(){
 
    if(this.meetingResponse.commonMomStatusCode == 'A'){
      this.disaleAttachmentFileIcon = true;
    }else{
      this.disaleAttachmentFileIcon = false;
    }
  }

  createEmpty(event:any){
    var selectTextAsNote = (event.altKey  &&  event.keyCode == 78);//(ALT+N)
    var selectTextAsDecision = (event.altKey  &&  event.keyCode == 68);//(ALT+D)
    var selectTextAsTask = (event.altKey  &&  event.keyCode == 84);//(ALT+T)
    var createAgenda = (event.altKey  &&  event.keyCode == 71)
    if(selectTextAsNote){
      this.createEmptyNote(event);
    }
    else if(selectTextAsTask){
      this.createEmptyTask(event);
    }
    else if(selectTextAsDecision){
      this.createEmptyDecision(event)
    }
    else if(createAgenda){
      this.createEmptyAgenda(event)
    }   

  }
  onUpdateTimerTracker(updatedArray: number[]) {
    this.timerTrackerArray = updatedArray;
  }
 /* getTaskUpdateStatus(event : any){
    this.isTaskUpdated.emit(event);
  }*/
  onAgendaEditorFocus(agList: any) {
    const editableEl = document.getElementById('meetAgendaId' + agList.agendaId);
    if (editableEl) {
      this.commonService.constructFocusHolderForAgenda({ target: editableEl });
      this.sideNavService.closeAllAccordtion();
      this.sideNavService.smootherScroll(editableEl);
    }
  }

  onReadOnlyAgendaEditorReady(editor: any) {
    try {
      editor.isReadOnly = true;
      const toolbarEl = editor.ui.view.toolbar.element;
      if (toolbarEl && toolbarEl.parentElement) {
        toolbarEl.parentElement.removeChild(toolbarEl);
      }
    } catch {}
  }

  customElement(editor: any) {
    // Check if GeneralHtmlSupport is loaded
    const htmlSupport = editor.plugins.get('GeneralHtmlSupport');
    if (htmlSupport && htmlSupport.dataFilter) {
      const dataFilter = htmlSupport.dataFilter;
  
      // Allow all span elements with any attributes, classes, and styles
      dataFilter.allowElement('span');
      dataFilter.allowAttributes({
        name: 'span',
        attributes: true,
        classes: true,
        styles: true
      });
  
      // Allow agenda and task-related classes
      dataFilter.allowAttributes({
        name: 'span',
        classes: [
          'presentedByCls', 'atwho-inserted', 'agDurCls', 'agDurLabelCls',
          'assignCls', 'minDateCls', 'dueLabelCls', 'taskTimezoneCls'
        ]
      });
  
      // Allow specific attributes
      dataFilter.allowAttributes({
        name: 'span',
        attributes: [
          'contenteditable',
          'data-atwho-at-query',
          'id',
          'fkuserid',
          'data-original-title',
          'title'
        ]
      });
  
      // Allow contenteditable on multiple elements
      dataFilter.allowAttributes({
        name: /^(span|div|p)$/,
        attributes: {
          'contenteditable': /^(true|false)$/
        }
      });
    }
  }

  getMentionUsers(elem: HTMLElement) {
    return this.attendeeService.fetchUserListSource("").then((result: any) => {

      // 1 Read attribute safely (both lowercase and camelCase for compatibility)
      const existingOwnerIdsAttr =
        elem.getAttribute('existingownerids') || elem.getAttribute('existingOwnerIds') || '';

      // 2 Convert "197,198," → ["197","198"]
      const existingOwnerIds = new Set(
        existingOwnerIdsAttr
          .split(',')
          .map(id => id.trim())
          .filter(id => id) // remove empty values
      );


      // 3 Filter users - exclude those already selected
      return result
        .filter((u: any) => !existingOwnerIds.has(u.userId.toString()))
        .map((u: any) => {
          const name = u.userLastname
            ? `${u.userFirstname} ${u.userLastname}`
            : u.userFirstname;

          // CKEditor 5 requires the mention id to include the marker (e.g. "@Barney").
          // Provide numeric userId separately for our custom downcast rendering.
          const label = `@${name}`;
          return {
            id: label,           // must include marker for CKEditor mention
            text: name + ', ',   // insert name followed by comma+space
            name: name,
            email: u.userEmail,
            userId: u.userId.toString()
          };
        });
    });
  }

  // ===== Quill.js Integration for Agenda =====
  onQuillAgendaEditorReady(quill: Quill, agList: any) {
    try {
      const agendaId = agList.agendaId;
      this.quillAgendaInstances.set(agendaId, quill);
      this.activeQuillAgenda = quill;
      // Consider agenda interacted so explicit blur saves always persist
      this.agendaUserInteracted.set(agendaId, true);
      
      // Register with shared toolbar
      try {
        const selectorId = 'quill-shared-toolbar';
        quillSharedToolbar.registerEditor(quill, selectorId);
      } catch {}

      const rootEl = quill.root as HTMLElement;

      // Ensure legacy attributes
      const ensureLegacyAttrs = () => {
        try {
          rootEl.id = 'meetAgendaId' + agendaId;
          rootEl.classList.add('agendaMainCls');
          rootEl.setAttribute('agid', String(agendaId));
          rootEl.setAttribute('agendaTraceId', String(agList.agendaTraceId || ''));
          rootEl.setAttribute('agendaTimerFlag', String(agList.agendaFlag || ''));
          
          // Set agendatime attribute for duration validation
          const currentDuration = agList.agendaDuration || '';
          rootEl.setAttribute('agendatime', String(currentDuration));
          
          // Set existing presenters for @mention filtering
          try {
            const presenters = (agList.agendaPresenterList?.length) ? agList.agendaPresenterList : [];
            const ids = presenters
              .map((p: any) => {
                const id = (p && (p.presenterUserId || p.userId));
                return id != null ? String(id) : '';
              })
              .filter((s: string) => !!s);
            const attrVal = ids.length ? ids.join(',') + ',' : '';
            if (attrVal) rootEl.setAttribute('existingownerids', attrVal);
          } catch {}
        } catch {}
      };
      ensureLegacyAttrs();
      // Normalize duration spans and strip BOM/ZWSP to keep popup working after reload
      try { this.normalizeAgDurSpans(rootEl, agList); } catch {}
      
      // Attach click handler for duration popover on agDurCls spans
      try {
        rootEl.addEventListener('click', (ev: MouseEvent) => {
          const target = ev.target as HTMLElement;
          if (target && (target.classList.contains('agDurCls') || target.classList.contains('agDurLabelCls'))) {
            // Trigger the popover handler
            this.openDurationPopover(agList, { target: target.classList.contains('agDurLabelCls') ? target.parentElement : target });
            ev.stopPropagation();
          }
        }, true);
      } catch {}

      // Guard blur-save while clicking toolbar
      const selectorId = 'quill-shared-toolbar';
      const shared = document.querySelector('#' + selectorId) as HTMLElement | null;
      if (shared) {
        shared.style.display = 'block';
        shared.addEventListener('mousedown', () => { this.toolbarInteracting = true; }, true);
        shared.addEventListener('mouseup', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
        shared.addEventListener('click', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
      }

      // Outside click handler
      let outsideClickHandler: ((ev: MouseEvent) => void) | null = null;
      outsideClickHandler = (ev: MouseEvent) => {
        const isActive = this.activeQuillAgenda === quill;
        const hasInteracted = this.agendaUserInteracted.get(agendaId);
        if (!isActive || !hasInteracted) return;
        
        const t = ev.target as Node;
        const insideEditor = rootEl.contains(t);
        const insideToolbar = shared ? shared.contains(t) : false;
        
        if (!insideEditor && !insideToolbar) {
          this.activeQuillAgenda = undefined;
          this.onQuillAgendaBlur(agList);
        }
      };
      document.addEventListener('mousedown', outsideClickHandler, true);

      // Add handler to close presenter dropdown on outside click
      const closePresenterDropdown = (ev: MouseEvent) => {
        const targetEl = ev.target as HTMLElement;
        const insideDropdown = targetEl?.closest?.('.presenter-mention-dropdown') != null;
        const insideEditor = rootEl.contains(targetEl);
        
        if (!insideEditor && !insideDropdown) {
          this.showPresenterDropdown.set(agendaId, false);
          this.presenterMentionList.set(agendaId, []);
        }
      };
      document.addEventListener('mousedown', closePresenterDropdown, true);

      // Click -> mark as interacted
      rootEl.addEventListener('click', () => {
        ensureLegacyAttrs();
        this.activeQuillAgenda = quill;
        this.agendaUserInteracted.set(agendaId, true);
        try { this.normalizeAgDurSpans(rootEl, agList); } catch {}
      });

      // Mark active on direct interactions
      rootEl.addEventListener('mousedown', () => { 
        this.activeQuillAgenda = quill;
        this.agendaUserInteracted.set(agendaId, true);
      }, true);
      
      rootEl.addEventListener('focusin', () => { 
        this.activeQuillAgenda = quill;
        this.agendaUserInteracted.set(agendaId, true);
        this.onQuillAgendaFocus(agList);
      }, true);

      // Fire blur on real editor blur and selection loss as a fallback
      try {
        rootEl.addEventListener('focusout', () => {
          if (this.toolbarInteracting || this.blurSavingGuard) return;
          if (this.activeQuillAgenda !== quill) return;
          if (!this.agendaUserInteracted.get(agendaId)) return;
          setTimeout(() => this.onQuillAgendaBlur(agList), 0);
        }, true);
      } catch {}
      try {
        (quill as any).on('selection-change', (range: any, _old: any, _src: any) => {
          if (range == null) {
            if (this.toolbarInteracting || this.blurSavingGuard) return;
            if (this.activeQuillAgenda !== quill) return;
            if (!this.agendaUserInteracted.get(agendaId)) return;
            setTimeout(() => this.onQuillAgendaBlur(agList), 0);
          }
        });
      } catch {}

      // Keyboard helpers for slash shortcuts
      rootEl.addEventListener('keydown', (ev: KeyboardEvent) => {
        if (!this.agendaUserInteracted.get(agendaId)) {
          this.agendaUserInteracted.set(agendaId, true);
        }
        
        const keyCode = (ev as any).keyCode || ev.which;

        // Handle Enter for slash shortcuts: delete token, handle /dur inline, delegate others, then blur-save
        if (keyCode === 13) {
          try {
            const sel = quill.getSelection();
            if (!sel) return;
            const caret = sel.index;
            const MAX = 48;
            const start = Math.max(0, caret - MAX);
            // Window and ignore trailing whitespace visually after caret
            let seg = quill.getText(start, caret - start);
            const trailing = seg.match(/[\s\u00a0]+$/);
            const strip = trailing ? trailing[0].length : 0;
            const effEnd = caret - strip;
            const effLen = effEnd - start;
            if (effLen <= 0) return;
            seg = quill.getText(start, effLen);

            // Find last '/' and build token
            const slash = seg.lastIndexOf('/');
            if (slash < 0) return;
            let token = '/';
            for (let i = slash + 1; i < seg.length && token.length <= 5; i++) {
              const ch = seg[i];
              if (!/[a-z]/i.test(ch)) break;
              token += ch;
            }
            const valid = /^(\/nn|\/dd|\/tt|\/ag|\/sg|\/agl|\/sgl|\/ddl|\/ttl|\/nnl|\/dur)$/i;
            if (!valid.test(token)) return;

            // Delete only the token from Quill content
            const delLen = token.length + strip;
            quill.deleteText(effEnd - token.length, delLen, 'user');

            const t = token.toLowerCase();
            if (t === '/dur') {
              // Check if duration already exists - if so, just consume the token without adding
              try {
                const existingDur = rootEl.querySelector('.agDurCls');
                if (existingDur) {
                  // Duration already exists - just consume the /dur token and do nothing
                  ev.preventDefault();
                  ev.stopPropagation();
                  return;
                }
                
                // Insert duration chip inline
                const defaultDur = String((this.globals as any)?.defaultAgendaDuration ?? 10).trim() || '10';
                const durHtml = `&nbsp;<span contenteditable="false" class="agDurCls" data-minutes="${defaultDur}"><span class="agDurLabelCls">[ </span>${defaultDur}<span class="agDurLabelCls"> Minutes ]</span></span>`;
                const startPos = effEnd - token.length; // position at token start
                quill.clipboard.dangerouslyPasteHTML(startPos, durHtml, 'user');
                // Move caret after chip and a space
                quill.insertText(startPos + 1 + 2 + defaultDur.length + 10, ' ', 'user');
                quill.setSelection(startPos + 1 + 2 + defaultDur.length + 11, 0, 'user');
              } catch {}
            } else {
              // Delegate others to legacy handler
              ensureLegacyAttrs();
              try {
                if (t === '/ag') {
                  try { rootEl.removeAttribute('parentAgId'); } catch {}
                } else if (t === '/sg') {
                  try { rootEl.setAttribute('parentAgId', String(agendaId)); } catch {}
                }
              } catch {}
              const syntheticEvent: any = {
                target: rootEl,
                currentTarget: rootEl,
                preventDefault: () => {},
                cancel: () => {}
              };
              this.commonService.trackAgendaEventOnClick(syntheticEvent, t);
            }

            // Mark interacted and force immediate and delayed blur-saves
            try { this.agendaUserInteracted.set(agendaId, true); } catch {}
            try { setTimeout(() => this.onQuillAgendaBlur(agList), 50); } catch {}
            try { setTimeout(() => this.onQuillAgendaBlur(agList), 300); } catch {}

            ev.preventDefault(); ev.stopPropagation();
            return;
          } catch {}
        }
      });

      // Upload adapter
      try {
        const cfg = this.agoraConfig.getConfig();
        setupQuillUploadAdapter(
          quill,
          cfg.apiBaseUrl,
          cfg.endpoints.attachment,
          this.meetingResponse?.meetingId,
          agList.agendaId,
          (_url: string) => { try { setTimeout(() => this.onQuillAgendaBlur(agList), 0); } catch {} }
        );
      } catch {}

      // Configure @mention module
      try {
        const mention: any = (quill as any).getModule && (quill as any).getModule('mention');
        if (mention) {
          // Ensure trigger settings
          try {
            mention.options.mentionDenotationChars = ['@'];
            mention.options.minChars = 0;
            mention.options.isolateCharacter = false;
          } catch {}
          mention.options.source = async (searchTerm: string, renderList: Function) => {
            try {
              const users = await this.getMentionUsers(rootEl);
              const q = (searchTerm || '').trim().toLowerCase();
              const filtered = q 
                ? users.filter((u: any) => {
                    const nm = (u.name || (u.userLastname ? `${u.userFirstname} ${u.userLastname}` : u.userFirstname) || '').toLowerCase();
                    return nm.includes(q);
                  })
                : users;
              
              const items = filtered.map((u: any) => {
                const id = String(u.userId ?? u.id ?? '');
                const name = u.name || (u.userLastname ? `${u.userFirstname} ${u.userLastname}` : u.userFirstname) || '';
                const email = u.email || u.userEmail || '';
                return { id, value: name, name, email, userId: id };
              });
              
              renderList(items, searchTerm);
            } catch (err) {
              console.error('Error fetching mention users:', err);
              renderList([], searchTerm);
            }
          };
          
          mention.options.renderItem = (item: any, searchTerm: string) => {
            const container = document.createElement('div');
            container.className = 'mention-item';
            
            const nameEl = document.createElement('div');
            nameEl.className = 'mention-item__name';
            nameEl.textContent = item.name;
            
            const emailEl = document.createElement('div');
            emailEl.className = 'mention-item__email';
            emailEl.textContent = item.email || '';
            
            container.appendChild(nameEl);
            container.appendChild(emailEl);
            
            return container;
          };
          
          mention.options.onSelect = (item: any, _insertItem: Function) => {
            try {
              const userId = String(item.id || item.userId || '');
              const name = String(item.name || item.value || '').trim();
              if (!userId || !name) return;

              const sel = quill.getSelection(true) || { index: quill.getLength(), length: 0 };
              let insertIndex = sel.index;
              // Find last '@' within a reasonable window and delete '@query'
              const MAX = 48;
              const start = Math.max(0, insertIndex - MAX);
              const segment = quill.getText(start, insertIndex - start);
              const atPos = segment.lastIndexOf('@');
              const delStart = atPos >= 0 ? (start + atPos) : insertIndex;
              const delLen = insertIndex - delStart;
              if (delLen > 0) {
                quill.deleteText(delStart, delLen, 'user');
                insertIndex = delStart;
              }
              // Insert our custom blot and a space after it
              (quill as any).insertEmbed(insertIndex, 'atwhomention', { userId, name }, 'user');
              quill.insertText(insertIndex + 1, ' ', 'user');
              quill.setSelection(insertIndex + 2, 0, 'user');

              // Update existingownerids
              try {
                const prev = rootEl.getAttribute('existingownerids') || rootEl.getAttribute('existingOwnerIds') || '';
                const existingIds = prev.split(',').filter(Boolean);
                if (!existingIds.includes(userId)) {
                  rootEl.setAttribute('existingownerids', (prev + userId + ',').replace(/,,+/g, ','));
                }
              } catch {}
            } catch (err) {
              console.error('Error inserting mention:', err);
            }
          };
        }
      } catch (err) {
        console.error('Error configuring mention module:', err);
      }

      // 👇 @ Mention keyboard handlers for presenters
      this.presenterActiveIndex.set(agendaId, 0);
      this.presenterMentionIndex.set(agendaId, 0);
      this.showPresenterDropdown.set(agendaId, false);
      this.presenterMentionList.set(agendaId, []);

      // Arrow Down - Navigate down in presenter dropdown
      quill.keyboard.addBinding(
        { key: 40 },
        (range: any, context: any) => {
          const isOpen = this.showPresenterDropdown.get(agendaId) || false;
          const list = this.presenterMentionList.get(agendaId) || [];
          const isDropdownOpen = isOpen && list.length > 0;

          if (!isDropdownOpen) return true;

          let idx = this.presenterActiveIndex.get(agendaId) || 0;
          idx = (idx + 1) % list.length;
          this.presenterActiveIndex.set(agendaId, idx);

          this.cd.markForCheck();
          this.scrollActivePresenterItemIntoView(agendaId);

          return false;
        }
      );

      // Arrow Up - Navigate up in presenter dropdown
      quill.keyboard.addBinding(
        { key: 38 },
        (range: any, context: any) => {
          const isOpen = this.showPresenterDropdown.get(agendaId) || false;
          const list = this.presenterMentionList.get(agendaId) || [];
          const isDropdownOpen = isOpen && list.length > 0;

          if (!isDropdownOpen) return true;

          let idx = this.presenterActiveIndex.get(agendaId) || 0;
          idx = (idx - 1 + list.length) % list.length;
          this.presenterActiveIndex.set(agendaId, idx);

          this.cd.markForCheck();
          this.scrollActivePresenterItemIntoView(agendaId);

          return false;
        }
      );

  // ============= DIRECT KEYDOWN LISTENER FOR ENTER KEY =============
  // This is in CAPTURE phase - runs BEFORE Quill processes the event
  rootEl.addEventListener('keydown', (event: KeyboardEvent) => {
    const isEnter = event.keyCode === 13 || event.key === 'Enter';
    const isOpen = this.showPresenterDropdown.get(agendaId) || false;
    const list = this.presenterMentionList.get(agendaId) || [];
    const isDropdownOpen = isOpen && list.length > 0;
    
    if (!isEnter) return; // Not Enter key, let it through
    
    if (!isDropdownOpen) {
      return; // Dropdown closed, allow normal Enter (newline)
    }

    // DROPDOWN IS OPEN - BLOCK ENTER AND SELECT ITEM
    event.preventDefault(); // STOP THE EVENT COMPLETELY
    event.stopPropagation();
    
    const idx = this.presenterActiveIndex.get(agendaId) || 0;
    const user = list[idx];
    
    if (user) {
      this.insertPresenter(user, agendaId);
      
      // Close dropdown after selection
      this.showPresenterDropdown.set(agendaId, false);
      this.presenterMentionList.set(agendaId, []);
      this.presenterActiveIndex.set(agendaId, 0);

      this.cd.markForCheck();
    } else if (list.length > 0) {
      this.insertPresenter(list[0], agendaId);
      
      // Close dropdown after selection
      this.showPresenterDropdown.set(agendaId, false);
      this.presenterMentionList.set(agendaId, []);
      this.presenterActiveIndex.set(agendaId, 0);

      this.cd.markForCheck();
    }
  }, true); // Capture phase - runs BEFORE Quill's handlers

      // Text change listener for @ mention
      quill.on('text-change', async () => {
        const range = quill.getSelection();
        if (!range) return;

        const textBefore = quill.getText(0, range.index);
        const match = textBefore.match(/@([\w\s]*)$/);

        if (match) {
          const queryText = match[1] || '';
          this.presenterMentionIndex.set(agendaId, range.index - match[0].length);

          const users = await this.getMentionUsers(rootEl);

          // ALWAYS show full list when only @
          if (queryText.length === 0) {
            this.presenterMentionList.set(agendaId, users);
          } else {
            const filtered = users.filter((u: any) =>
              u.name.toLowerCase().includes(queryText.toLowerCase())
            );
            this.presenterMentionList.set(agendaId, filtered);
          }

          const hasUsers = (this.presenterMentionList.get(agendaId) || []).length > 0;
          this.showPresenterDropdown.set(agendaId, hasUsers);

          if (hasUsers) {
            // 👇 Calculate responsive dropdown position with proper offset
            try {
              const bounds = quill.getBounds(range.index) || { top: 0, left: 0, height: 0 };
              const dropdownHeight = 300; // Expected dropdown height (adjust if needed)
              const viewportHeight = window.innerHeight;
              const spaceBelow = viewportHeight - (bounds.top + bounds.height);
              const DROPDOWN_OFFSET = 25; // Offset to show @ and search text
              const HORIZONTAL_OFFSET = 10; // Slight horizontal adjustment
              
              let top: number;
              if (spaceBelow > dropdownHeight) {
                // Enough space below - position dropdown below the caret with offset
                top = bounds.top + bounds.height + DROPDOWN_OFFSET;
              } else {
                // Not enough space below - position dropdown above the caret with offset
                top = bounds.top - dropdownHeight - DROPDOWN_OFFSET;
              }
              
              const position = {
                top: Math.max(0, top),
                left: Math.max(0, bounds.left + HORIZONTAL_OFFSET)
              };
              
              this.dropdownPositionMap.set(agendaId, position);
            } catch (err) {
              console.warn('Error calculating dropdown position:', err);
              this.dropdownPositionMap.set(agendaId, { top: 0, left: 0 });
            }

            this.presenterActiveIndex.set(agendaId, 0);
            this.cd.markForCheck();
            setTimeout(() => this.scrollActivePresenterItemIntoView(agendaId), 0);
          }
        } else {
          this.showPresenterDropdown.set(agendaId, false);
          this.presenterMentionList.set(agendaId, []);
          this.presenterActiveIndex.set(agendaId, 0);
          // Trigger change detection to hide dropdown
          this.cd.markForCheck();
        }
      });

    } catch {}
  }

  onQuillAgendaBlur(agList: any) {
    try {
      const agendaId = agList.agendaId;
      // if (this.toolbarInteracting || this.blurSavingGuard) return;
      
      // Close presenter dropdown on blur
      this.showPresenterDropdown.set(agendaId, false);
      this.presenterMentionList.set(agendaId, []);
      
      this.blurSavingGuard = true;
      
      const editableEl = document.getElementById('meetAgendaId' + agendaId) as HTMLElement | null;
      if (editableEl) {
        // Extract presenters from HTML and sync to data model
        try {
          const parsedPresenters = this.extractPresentersFromHtml(editableEl.innerHTML);
          // Only update agendaPresenterList if we found presenters with valid names
          const validPresenters = parsedPresenters.filter(p => p.presenterName && p.presenterName.trim());
          if (validPresenters.length > 0) {
            agList.agendaPresenterList = validPresenters;
          } else if (parsedPresenters.length > 0) {
            console.warn('[agenda] Found presenters but all have empty names, not updating model');
          }
        } catch (err) {
          console.warn('Error extracting presenters:', err);
        }
        
        editableEl.setAttribute('agid', String(agendaId));
        editableEl.setAttribute('agendaTraceId', String(agList.agendaTraceId || ''));
        editableEl.setAttribute('agendaTimerFlag', String(agList.agendaFlag || ''));
        
        setTimeout(() => {
          const evt: any = { target: editableEl };
          this.commonService.callOnBlur(evt, agList);
          this.commonMinService.activateCkeditor(editableEl);
          
          setTimeout(() => { this.blurSavingGuard = false; }, 100);
        }, 0);
      }
    } catch (err) {
      console.error('Quill agenda blur error:', err);
      setTimeout(() => { this.blurSavingGuard = false; }, 300);
    }
  }

  private extractPresentersFromHtml(html: string): Array<{ presenterUserId: any, presenterName: string }> {
    const presenters: Array<{ presenterUserId: any, presenterName: string }> = [];
    if (!html) return presenters;
    try {
      // Log raw HTML for debugging  
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const body = doc.body;
      
      // Extract from atwho-inserted spans
      const atwhoSpans = body.querySelectorAll('.atwho-inserted');
      
      atwhoSpans.forEach((span: Element, idx: number) => {
        const userId = (span.getAttribute('fkuserid') || span.getAttribute('id') || '').trim();
        const rawTextContent = span.textContent || '';
        const name = rawTextContent.replace(/^[,\s]+|[,\s]+$/g, '').trim();     
        // Include presenter even if name is empty for debugging
        presenters.push({ presenterUserId: userId, presenterName: name });
      });
      
    } catch (err) {
      console.error('[agenda] Error parsing presenters from HTML:', err);
    }
    return presenters;
  }

  private normalizeAgDurSpans(scope: HTMLElement, agList: any) {
    try {
      // Strip BOM/ZWSP in scope
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      const texts: Text[] = [];
      while (walker.nextNode()) texts.push(walker.currentNode as Text);
      texts.forEach(t => { if (/[\uFEFF\u200B]/.test(t.data)) t.data = t.data.replace(/[\uFEFF\u200B]/g, ''); });

      const nodes = Array.from(scope.querySelectorAll('span.agDurCls')) as HTMLSpanElement[];
      nodes.forEach((el) => {
        try {
          // Root must be contenteditable=false and have labels
          el.setAttribute('contenteditable', 'false');
          const inner = el.querySelector('span[contenteditable="false"]') as HTMLElement | null;
          if (inner) {
            while (inner.firstChild) el.insertBefore(inner.firstChild, inner);
            inner.remove();
          }
          if (!el.querySelector(':scope > span.agDurLabelCls')) {
            const left = document.createElement('span');
            left.className = 'agDurLabelCls';
            left.textContent = '[ ';
            el.insertBefore(left, el.firstChild);
            const right = document.createElement('span');
            right.className = 'agDurLabelCls';
            right.textContent = ' Minutes ]';
            el.appendChild(right);
          }
          // Ensure numeric text between labels; default to 10 if missing/zero
          const textNodes = Array.from(el.childNodes).filter(n => n.nodeType === Node.TEXT_NODE) as Text[];
          let numberNode = textNodes.find(t => /\d+/.test(t.data || ''));
          if (!numberNode) {
            numberNode = document.createTextNode('10');
            const firstLabel = el.querySelector(':scope > span.agDurLabelCls');
            el.insertBefore(numberNode, firstLabel ? firstLabel.nextSibling : el.firstChild);
          } else if (!/\d+/.test(numberNode.data)) {
            numberNode.data = '10';
          }
          const minutes = (numberNode.data || '').match(/\d+/)?.[0] || '10';
          el.setAttribute('data-minutes', minutes);
          // Optional: remove title attributes noise
          el.removeAttribute('title');
          el.removeAttribute('data-original-title');
        } catch {}
      });
    } catch {}
  }

  onQuillAgendaFocus(agList: any) {
    const editableEl = document.getElementById('meetAgendaId' + agList.agendaId);
    if (editableEl) {
      this.commonService.constructFocusHolderForAgenda({ target: editableEl });
      this.sideNavService.closeAllAccordtion();
      this.sideNavService.smootherScroll(editableEl);
    }
  }

  onQuillAgendaSelectionChanged(e: any) {
    // DO NOT use selection-change for blur - handled by outside click
  }

  onReadOnlyQuillAgendaEditorReady(quill: Quill) {
    try {
      quill.enable(false);
    } catch {}
  }

  insertOwnerLabelBeforeFirstMention(editor: any) {
    editor.model.change((writer: any) => {
      const root = editor.model.document.getRoot();
  
      for (const block of root.getChildren()) {
        if (!block.is('element', 'paragraph')) continue;
  
        for (const child of block.getChildren()) {
          //first mention text node
          if (child.is('$text') && child.hasAttribute('mention')) {
            const insertPos = writer.createPositionBefore(child);
  
            const viewFragment = editor.data.processor.toView(
              '<span class="presentedByCls" contenteditable="false">Presented by&nbsp;</span>'
            );
  
            const modelFragment = editor.data.toModel(viewFragment);
  
            editor.model.insertContent(modelFragment, insertPos);
            return; 
          }
        }
      }
    });
  }


  private hslToRgb(h: number, s: number, l: number): string {
    s /= 100;
    l /= 100;
  
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;
  
    let r = 0, g = 0, b = 0;
  
    if (h < 60) [r, g, b] = [c, x, 0];
    else if (h < 120) [r, g, b] = [x, c, 0];
    else if (h < 180) [r, g, b] = [0, c, x];
    else if (h < 240) [r, g, b] = [0, x, c];
    else if (h < 300) [r, g, b] = [x, 0, c];
    else [r, g, b] = [c, 0, x];
  
    return `rgb(${Math.round((r + m) * 255)},${Math.round((g + m) * 255)},${Math.round((b + m) * 255)})`;
  }
  
  onPresenterItemClick(user: any, agendaId: number, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.insertPresenter(user, agendaId);
  }

  // Insert selected presenter in agenda
  insertPresenter(user: any, agendaId: number) {
    try {
      const quill = this.quillAgendaInstances.get(agendaId);
      if (!quill) return;

      const range = quill.getSelection(true);
      if (!range) return;

      let index = range.index;

      // Remove @query
      const mentionIndex = this.presenterMentionIndex.get(agendaId);
      if (mentionIndex != null) {
        quill.deleteText(
          mentionIndex,
          index - mentionIndex
        );
        index = mentionIndex;
      }

      // Get the full HTML content to check if label exists
      const rootEl = quill.root as HTMLElement;
      const html = rootEl.innerHTML || '';
      
      // Check if "Presented by" label already exists by looking for presentedByCls class
      const labelExists = html.includes('presentedByCls') || html.includes('Presented by');
      
      let insertHtml = '';
      
      // If label doesn't exist, add it first
      if (!labelExists) {
        insertHtml = '<span class="presentedByCls" contenteditable="false">Presented by&nbsp;</span>';
      }

      // Add the presenter mention span - comma should be INSIDE the span when adding subsequent presenters
      if (labelExists) {
        // Already have presenters - add comma before this presenter (comma inside span)
        insertHtml = `<span class="atwho-inserted" data-atwho-at-query="@" id="${user.userId}" fkuserid="${user.userId}" contenteditable="false">, ${user.name}</span>&nbsp;`;
      } else {
        // First presenter - no comma needed
        insertHtml += `<span class="atwho-inserted" data-atwho-at-query="@" id="${user.userId}" fkuserid="${user.userId}" contenteditable="false">${user.name}</span>&nbsp;`;
      }

      // Insert the complete HTML
      quill.clipboard.dangerouslyPasteHTML(index, insertHtml, 'user');
      
      // Move cursor after inserted content
      const insertedLength = insertHtml.replace(/<[^>]*>/g, '').length; // approximate text length
      quill.setSelection(index + insertedLength + 1, 0, 'user');

      // Update existingownerids attribute
      try {
        const prev = rootEl.getAttribute('existingownerids') || '';
        const existingIds = prev.split(',').filter(Boolean);
        if (!existingIds.includes(user.userId)) {
          rootEl.setAttribute('existingownerids', (prev + user.userId + ',').replace(/,,+/g, ','));
        }
      } catch {}

      /* 8️⃣ CLOSE DROPDOWN */
      this.showPresenterDropdown.set(agendaId, false);
      this.presenterMentionList.set(agendaId, []);
      this.presenterActiveIndex.set(agendaId, 0);
      
      // Trigger change detection for OnPush strategy
      this.cd.markForCheck();
    } catch (err) {
      console.error('Error inserting presenter:', err);
    }
  }

  // Scroll active presenter item into view when navigating with arrow keys
  scrollActivePresenterItemIntoView(agendaId: number) {
    try {
      setTimeout(() => {
        const selector = `.presenter-mention-item-${agendaId}.active`;
        const activeItem = document.querySelector(selector);
        if (activeItem && activeItem.parentElement) {
          const dropdownContainer = activeItem.parentElement;
          const itemTop = (activeItem as HTMLElement).offsetTop;
          const itemHeight = (activeItem as HTMLElement).offsetHeight;
          const containerTop = dropdownContainer.scrollTop;
          const containerHeight = dropdownContainer.clientHeight;

          // Scroll if item is below visible area
          if (itemTop + itemHeight > containerTop + containerHeight) {
            dropdownContainer.scrollTop = itemTop + itemHeight - containerHeight;
          }
          // Scroll if item is above visible area
          else if (itemTop < containerTop) {
            dropdownContainer.scrollTop = itemTop;
          }
        }
      }, 0);
    } catch {}
  }

  
}
